import { types } from "./mutations";
import omit from "lodash/omit";
import {
  fetchHistory,
  dumpHistoy,
  removeHistory,
} from "./searchHistory.helper";

export default {
  /**
   * Adds or updates geodata in the store
   * @param {Object} context
   * @param {Object} layerData
   * @param {Object} layerData.item_id id of the data
   * @param {Object} layerData.data GeoData corresponding to the id
   */
  addGeoData: async ({ state, commit }, { id, data }) => {
    try {
      if (!id) {
        throw new Error("Item Id not present");
      }
      commit(types.SET_GEO_DATA, {
        ...state.geoData,
        [id]: data, // override or adds new
      });
    } catch (error) {
      console.error("Unable to add geo data", { error });
    }
  },

  /**
   * Removes an exisiting geoItem from the store
   * @param {Object} context
   * @param {Object} itemData
   * @param {String} itemData.item_id id of the item to be removed
   */
  removeGeoData: async ({ state, commit }, { id }) => {
    try {
      if (!id) throw new Error("No item id provided");
      commit(types.SET_GEO_DATA, omit(state.geoData, id));
    } catch (error) {
      console.error("Unable to remove the geo item", { error });
    }
  },

  /**
   * Clears the exisiting geodata store
   */
  clearGeoData: async ({ commit }) => {
    commit(types.SET_GEO_DATA, {});
  },

  /**
   * Loads a new geoData object to the store
   */
  loadGeoData: async ({ commit }, { items }) => {
    try {
      if (!Object.keys(items)) throw new Error("No items passed to be loaded");
      commit(types.SET_GEO_DATA, items);
    } catch (error) {
      console.error("Unable to load geo items", { error });
    }
  },

  /**
   * gGt a specific Geo Data for the id
   * @param {Object} context
   * @param {Object} data
   * @param {String} id id of the item to be fetched
   */
  getGeoDataForId: async ({ state }, { id }) => {
    if (state.geoData && state.geoData[id]) {
      return state.geoData[id];
    } else {
      return null;
    }
  },

  /**
   * Loads the history from the localstorage to the state
   */
  loadHistory: async ({ commit }) => {
    let history = fetchHistory();
    try {
      history = history ? JSON.parse(history) : null;
      commit(types.SET_HISTORY, history);
      return history;
    } catch (error) {
      console.error("Courrupted search history in localstorage", { error });
    }
  },

  /**
   * Writes the histoy to the localstorage
   * @param {Object} context
   * @param {Arraay[Object]} data
   */
  writeHistory: async ({ commit }, data) => {
    commit(types.SET_HISTORY, data);
    let history = JSON.stringify(data);
    dumpHistoy(history);
  },

  /**
   * Adds a new history to the state and updates the localstorage
   * @param {Object} context
   * @param {Object} history
   */
  addHistory: async ({ commit }, history) => {
    let savedHistories = fetchHistory();
    try {
      savedHistories = JSON.parse(savedHistories);
      let newHistory = null;
      if (savedHistories && savedHistories.length > 0) {
        newHistory = [history, ...savedHistories.slice(0, 9)];
        dumpHistoy(JSON.stringify(newHistory));
      } else {
        newHistory = [history];
        dumpHistoy(JSON.stringify(newHistory));
      }
      commit(types.SET_HISTORY, newHistory);
    } catch (error) {
      console.error("Unable to add history", { error });
    }
  },

  /**
   * Clears the exisiting local search history
   */
  clearHistory: async ({ commit }) => {
    commit(types.SET_HISTORY, []);
    removeHistory();
  },

  /**
   * Resets the module
   */
  reset: async ({ commit }) => {
    commit(types.reset);
  },
};
